<template>
  <div
    v-if="status"
    id="demo-popup"
  >
    <div class="demo-popup-wrapper">
      <div class="demo-popup-header text-right">
        <div>
          <i
            class="icon-close pr-3 icon-3x cursor-pointer pt-3 fa-2x"
            @click="close"
          />
        </div>
      </div>
      <div class="demo-popup-body">
        <img
          class="demo-popup-carrot"
          :src="require('@/assets/imgIcons/demo-carrot.svg')"
          alt="demo carrot"
        >
        <div class="demo-popup-close" />
        <div class="demo-body-header">
          {{ resource['demoCompany.WelcomePopup.Header'] }}
        </div>
        <div
          class="demo-body-content"
          v-html="resource['demoCompany.WelcomePopup.Content']"
        />
      </div>
      <div class="demo-popup-footer" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'WelcomeDemoPopup',

  data() {
    return {
      status: false,
    };
  },

  mounted() {
    if (localStorage.getItem('firstLoginDemo') === 'true') this.status = true;
  },
  methods: {
    close() {
      this.status = false;
      localStorage.setItem('firstLoginDemo', false);
    },
  },
};
</script>
<style lang="scss">
#demo-popup {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999999999;
  font-family: Roboto-m;
}
.fa-remove {
  cursor: pointer;
}
#demo-popup .demo-popup-wrapper {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
  height: 400px;
  padding-top: 10px;
  width: 560px;
  border-radius: 8px;
  background-color: #ffffff;
}

#demo-popup .demo-popup-body {
  padding-right: 80px;
  position: relative;
  padding-left: 80px;
}

#demo-popup .demo-body-header {
  color: #353535;
  font-family: Roboto;
  font-size: 32px;
  padding-top: 20px;
  padding-bottom: 14px;
  font-weight: bold;
  line-height: 45px;
}

#demo-popup .demo-body-content {
  color: #353535;
  font-family: Roboto;
  font-size: 20px;
  padding-bottom: 40px;
}

#demo-popup .demo-body-buttons {
  text-align: center;
}

#demo-popup .demo-popup-carrot {
  position: absolute;
  left: 0px;
  top: -55px;
  z-index: -1;
}

#demo-popup .demo-popup-close {
  cursor: pointer;
  width: 21px;
  height: 22px;
  right: 30px;
  background-position: 0px -100px;
  position: absolute;
  top: 30px;
}
</style>
